import user from './user'
import security from './security'
import rules from './rules'
import profile from './profile'
import dashboard from './dashboard'
import dialog from './dialog'
import accessPlatform from './access-platform'
import durations from './durations'
import applicationSettings from './application-settings'
import common from './common'

export default {
  common,
  user,
  security,
  rules,
  profile,
  dashboard,
  dialog,
  accessPlatform,
  durations,
  applicationSettings
}
